import CoreCompaniesRepository from "@/repositories/CompaniesRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'corecompanies',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetch(id).then(response => {
                commit('setCurrent', response.data)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        },
        async listAllPaginated ({ commit }, params) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetchAllPaginated(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async listInVs ({ commit }, params) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetchAllInVs(params).then(response => {
                commit('setAll', response.data.empresas)
            })
            commit('setLoading', false)
        },
        async listOneInVs ({ commit }, id) {
            commit('setLoading', true)
            await CoreCompaniesRepository.fetchInVs(id).then(response => {
                commit('setCurrent', response.data)
            })
            commit('setLoading', false)
        }
    }
}
